'use client';

import Link from 'next/link';
import { useLenis } from 'lenis/react';
import { usePathname } from 'next/navigation';
import { useContentSize } from '@/components/SizeProvider';
import { getTitleFontSize } from '@/lib/utils/typography';
import ContactButton from '@/components/ContactButton';
import { ROUTES } from '@/lib/routes';

const CONTACT_BUTTON_FONT_RATIO = 0.06;
const CONTACT_BUTTON_HEIGHT_DIVISOR = 22;

const ContactInfo = () => {
  const { width: widthContent, height: heightContent } = useContentSize();
  const contactButtonSize = heightContent / 9 + widthContent / 16;
  const lenis = useLenis();
  const pathname = usePathname();
  const isBlogPage = pathname?.startsWith(ROUTES.blog) ?? false;

  const onBlogClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Already on /blog: re-navigating remounts the index and reshuffles the
    // randomly-placed cards. Cancel the navigation and just scroll to the top.
    if (pathname === ROUTES.blog) {
      event.preventDefault();
      if (lenis) lenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={'contact-wrapper'}>
      <h2 className='text-gray letter-scrambler'>{'\\\\SOCIALS\\\\'}</h2>
        <a 
          href="https://www.instagram.com/theotherlab.co/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className='letter-scrambler social-item'
          style={{ fontSize: getTitleFontSize(widthContent, { ceil: false }) }}
        >
          INSTAGRAM
        </a>
        {/* <Link
          href={ROUTES.blog}
          onClick={onBlogClick} 
          className={`letter-scrambler social-item ${isBlogPage ? 'social-item-active' : ''}`}
          style={{ fontSize: getTitleFontSize(widthContent, { ceil: false }) }}
        >
          BLOG
        </Link> */}
        
        <p className='text-gray text-gray-separator'>{"<>"}</p>
        <h2 className='text-gray letter-scrambler'>{'\\\\REACH\\\\'}</h2>
        <div>
          <p className='letter-scrambler'>195 PEARL'S HILL TERRACE</p>
          <p className='letter-scrambler'>#03-76 SINGAPORE 168976</p>
        </div>
        <p className='text-gray final-or letter-scrambler'>{'< OR >'}</p>
      <ContactButton fontSize={contactButtonSize * CONTACT_BUTTON_FONT_RATIO} style={{ height: heightContent / CONTACT_BUTTON_HEIGHT_DIVISOR }} />
    </div>
  )
};

export default ContactInfo
